import { InputBase } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import {
  parseFullNumberToHalf,
  parseTimeToDecimal,
} from '../../../../../utils/number'
import { DecimalAndSexagesimalScale } from '../../../../../lib/functions/decimalAndSexagesimalScale'
import { convertDecimalHourToHM } from '../../../../../utils/time'
import { CustomCellEditorProps } from 'ag-grid-react'

const parseActualWorkTime = (value: unknown): number | undefined => {
  if (value === undefined || value === null) return undefined
  const str = value.toString()
  if (
    str.includes(':') ||
    str.includes('：') ||
    str.includes(';') ||
    str.includes('；')
  ) {
    const num = parseTimeToDecimal(str)
    return Number.isFinite(num) ? Number(num.toFixed(2)) : undefined
  }
  const halfStr = parseFullNumberToHalf(str)
  const num = parseFloat(halfStr)
  return Number.isFinite(num) ? Number(num.toFixed(2)) : undefined
}

export const ActualWorkTimeCellEditor = (props: CustomCellEditorProps) => {
  const [value, setValue] = useState(
    (props.eventKey?.length === 1 ? props.eventKey : null) ?? props.value ?? ''
  )

  const inputRef = useRef<HTMLInputElement>(null)

  // Reactive mode: eventKey（1文字キー押下）で編集開始した場合、初期値をAG Gridに通知
  useEffect(() => {
    if (props.eventKey?.length === 1) {
      props.onValueChange(parseActualWorkTime(props.eventKey))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- マウント時のみ実行。eventKey由来の初期値をAG Gridに通知
  }, [])

  useEffect(() => {
    inputRef.current?.focus()
    const isCellEmpty = typeof value !== 'number'
    if (isCellEmpty) return
    if (
      props.context.decimalScaleUnit === DecimalAndSexagesimalScale.SEXAGESIMAL
    ) {
      value && setValue(convertDecimalHourToHM(value))
    }
    if (props.context.decimalScaleUnit === DecimalAndSexagesimalScale.DECIMAL) {
      value && setValue(value.toFixed(2))
    }
  }, [])

  return (
    <InputBase
      inputRef={inputRef}
      value={value}
      onChange={e => {
        setValue(e.target.value)
        props.onValueChange(parseActualWorkTime(e.target.value))
      }}
    />
  )
}
